export default __webpack_public_path__ + "static/media/close_cookies_icon.9548c21d.svg";